	app.service('browser', ['$window', function($window) {
		
	  this.getBrowserType = function () {

			var userAgent = $window.navigator.userAgent;
			var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i};

			for(var key in browsers) {
				if (browsers[key].test(userAgent)) {
					return key;
				}
		   };
		   return 'unknown';

	 };
		this.getDeviceType = function () {

			var userAgent = $window.navigator.userAgent;
			var devices = {android: /Android/i, blackBerry: /BlackBerry/i, ios: /iPhone|iPad|iPod/i, opera: /Opera Mini/i, windows: /IEMobile/i};

			for(var key in devices) {
				if (devices[key].test(userAgent)) {
					return true;
				}
			};
			return false;

		};

		this.getBrowserWidth = function () {
			if ($window.innerWidth < 768) {
				// Extra Small Device
				return "xs";
			} else if ($window.innerWidth < 991) {
				// Small Device
				return "sm"
			} else if ($window.innerWidth < 1199) {
				// Medium Device
				return "md"
			} else {
				// Large Device
				return "lg"
			}
		};
	}]); //end window resize

	app.service("highlighter", function(){
	  this.highlightFields = function(fieldTarget){
		$('#'+fieldTarget).addClass('highlighted');
	  }
	  this.highlightQuoteFields = function(fieldTarget){
		$('#'+fieldTarget).addClass('highlighted');
	  }
	  this.removeHighlightFields = function (fieldTarget) {
	      $('#' + fieldTarget).removeClass('highlighted');
	  }
	});
	
	app.service("pageactions", function( ){
		
	  this.openpopup = function(pageTarget){
		//$( "#"+pageTarget ).popup( "open" );
	  };
	  this.openpage = function(pageTarget){
		//$.mobile.changePage( "#"+pageTarget , { transition: "slide"} );
	  };
	  this.functionCall = function(action){
		  //alert(action);
		  return function (scope) {
			  scope.$apply(function() { 
				scope.$eval(action);
				//scope.setPageName(attrs.pagename);
			  });
		  }
	  };
	});
